import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  RiArrowLeftSLine,
  RiArrowRightSLine,
  RiHeartLine,
  RiSearchLine,
  RiLayoutGridLine,
  RiTeamLine,
  RiUserFollowLine,
  RiMessage3Line,
} from "react-icons/ri";
import Logo from "./Logo";

interface SidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const Sidebar = ({ isCollapsed, onToggle }: SidebarProps) => {
  const location = useLocation();

  const menuItems = [
    { path: "/attractiveness", label: "Attractiveness", icon: <RiHeartLine /> },
    { path: "/fit-finder", label: "Fit Finder", icon: <RiSearchLine /> },
    { path: "/grid", label: "Grid", icon: <RiLayoutGridLine /> },
    { path: "/crm", label: "CRM", icon: <RiTeamLine /> },
    {
      path: "/introductions",
      label: "Introductions",
      icon: <RiUserFollowLine />,
    },
    { path: "/sms", label: "SMS", icon: <RiMessage3Line /> },
  ];

  return (
    <div
      className={`h-screen bg-amber-50 transition-all duration-300 ${
        !isCollapsed ? "w-64" : "w-16"
      } fixed left-0 top-0 z-10`}
    >
      <button
        className="absolute -right-3 top-9 bg-amber-100 rounded-full p-1 border border-amber-200"
        onClick={onToggle}
      >
        {!isCollapsed ? <RiArrowLeftSLine /> : <RiArrowRightSLine />}
      </button>
      <div
        className={`flex items-center justify-center pt-10 px-4 ${
          isCollapsed && "hidden"
        }`}
      >
        <Link to="/">
          <Logo />
        </Link>
      </div>
      <div className={`${!isCollapsed ? "pt-10" : "pt-20"} px-4`}>
        <ul className="flex flex-col gap-4">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center gap-4 text-black hover:bg-amber-100 rounded-lg p-2 transition-colors ${
                  location.pathname === item.path ? "bg-amber-200" : ""
                }`}
              >
                <span className="text-xl">{item.icon}</span>
                {!isCollapsed && <span>{item.label}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
